import http from './http';

export default {
  getAgentWhatsappCampaigns(agentId) {
    return http.get(`agents/${agentId}/campaigns/whatsapp`);
  },
};
